import ReactHtmlParser from "html-react-parser";
import PropTypes from "prop-types";
import React from "react";
import { Banner } from "./Banner";
import { QueryParam } from "../../commons/Constants";
import Logger from "../../commons/Logger";
import { AdContent } from "../AdContent";
import { DomainDisplay } from "./DomainDisplay";
import { FooterCashParking } from "./FooterCashParking";
import { ArrowUIWrapper } from "./ArrowUIWrapper";

import classes from "./SimpleLayout.module.scss";
import { useLanderConfig } from "../../commons/ConfigContext";

const SimpleLayout = () => {
  const { landerConfig, queryConfig } = useLanderConfig();

  let domain;

  // default is false for this template
  const domainName =
    landerConfig.lander.domainDisplayName || landerConfig.domain.rootDomain;

  if (
    typeof queryConfig[QueryParam.SHOW_DOMAIN] === "boolean"
      ? queryConfig[QueryParam.SHOW_DOMAIN]
      : landerConfig.lander.showDomain
  ) {
    domain = (
      <DomainDisplay
        domainName={ domainName }
        className={ classes.domainDisplay }
      />
    );
  }

  let headerElement;
  if (landerConfig.lander.headerHtml) {
    let decodedHtml = "";
    try {
      decodedHtml = window.atob(landerConfig.lander.headerHtml);
    } catch (e) {
      Logger.error("headerHtml value is not properly encoded" + e.toString());
    }
    headerElement = <HeaderHtmlElement headerHtml={ decodedHtml } />;
  } else if (landerConfig.lander.headerText) {
    headerElement = (
      <HeaderTextElement headerText={ landerConfig.lander.headerText } />
    );
  }

  const renderAdContent = () => {
    const ads = (
      <div className={ classes.relatedLinks }>
        <AdContent />
      </div>
    );
    return (
      <ArrowUIWrapper template={ landerConfig.lander.template }>
        {ads}
      </ArrowUIWrapper>
    );
  };

  return (
    <div data-testid="simpleLayout">
      <div className={ classes.contentLayout }>
        <div>
          <Banner landerConfig={ landerConfig } queryConfig={ queryConfig } />

          {headerElement}
          {domain}
        </div>
        <div>{renderAdContent()}</div>
        <FooterCashParking />
      </div>
    </div>
  );
};

SimpleLayout.propTypes = {};

export default SimpleLayout;

export function HeaderHtmlElement({ headerHtml }) {
  // eslint-disable-next-line new-cap
  return <div id="headerElement">{ReactHtmlParser(headerHtml)}</div>;
}

export function HeaderTextElement({ headerText }) {
  return <div id="headerElement">{headerText}</div>;
}

HeaderHtmlElement.propTypes = {
  headerHtml: PropTypes.string.isRequired,
};

HeaderTextElement.propTypes = {
  headerText: PropTypes.string.isRequired,
};
